module.exports = __webpack_public_path__ + "img/SubstanceThermalStabilityDetailed-min.8298beff.png";